import { useEffect, useRef } from "react";
import styles from "./LoanRepayment.module.scss";
import CustomButton from "../Button/CustomButton";
import { FaArrowRightLong } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import { clevertap_loan_repayment_lending_screen,  clevertap_loan_repayment_lending_screen_click} from "../../lib/clevertap-events";

export default function LoanRepayment({ data }) {
  const isCTEventOnLoadTrigger = useRef(false)
  const navigate = useNavigate();
  useEffect(() => {
    if(Object.keys(data).length && !isCTEventOnLoadTrigger.current) {

      isCTEventOnLoadTrigger.current = true;
      clevertap_loan_repayment_lending_screen({
        amount: data?.dashboard_message6
      });
    }
  }, [data])
  return (
    <div className={styles.loanRepayment}>
      <div className="text-center">
        <div className={`${styles.message} ${data.isLoanOverDue ? styles.overdueMessage : ""}`}>
          <span>{data.dashboard_message1}</span>
        </div>
      </div>

      <div>
        <p className={styles.title}>{data.dashboard_message2}</p>
        <div className={styles.paymentAmount}>
          <h2>₹{data.dashboard_message6}</h2>
          {data.isLoanOverDue && <div className={styles.overdueDate}>{data.dashboard_message5}</div>}
        </div>

        {data.isLoanOverDue ? (
          <p className={styles.greetMessage}>{data.dashboard_message7}</p>
        ) : (
          <p className={styles.greetMessage}>{data.dashboard_message5}</p>
        )}

        <div className={styles.dueDate}>
          <div className={styles.dateLabel}>Due Date</div>
          <div className={data.isLoanOverDue ? styles.dateValueOverdue : styles.dateValue}>
            {data.dashboard_message4}
          </div>
        </div>

        <div className={styles.button}>
          <CustomButton
            floating={false}
            text={data?.dashboard_message3}
            endIcon={<FaArrowRightLong />}
            onClick={() => {
              clevertap_loan_repayment_lending_screen_click({
                amount: data?.dashboard_message6,
                due_date: data?.dashboard_message4
              })
              if (data?.dashboard_message3 === "Repay Loan") {
                navigate("/re-payment");
              } else {
                navigate(data.step.current_route);
              }
            }}
            size="lg"
            disabled={!data.buttonEnable}
          />
        </div>
      </div>
    </div>
  );
}
